import { useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { api } from '@/api/client'

const ENDPOINT = '/assistant-bridge-usage'

export function useAssistantBridgeUsage() {
  const [daysBack, setDaysBack] = useState(30)
  const [platform, setPlatform] = useState('all')
  const [profile, setProfile] = useState('all')
  const [toolName, setToolName] = useState('all')
  const [actorHash, setActorHash] = useState('')

  const usageQuery = useQuery({
    queryKey: ['assistant-bridge-usage', daysBack, platform, profile, toolName, actorHash],
    queryFn: () => {
      const params = new URLSearchParams({ daysBack: String(daysBack) })

      if (platform !== 'all') params.set('platform', platform)
      if (profile !== 'all') params.set('profile', profile)
      if (toolName !== 'all') params.set('toolName', toolName)
      if (actorHash.trim()) params.set('actorHash', actorHash.trim())

      return api.get(`${ENDPOINT}?${params}`)
    },
  })

  return {
    daysBack,
    setDaysBack,
    platform,
    setPlatform,
    profile,
    setProfile,
    toolName,
    setToolName,
    actorHash,
    setActorHash,
    summary: usageQuery.data?.summary || {
      totalEvents: 0,
      toolCalls: 0,
      activeActors: 0,
      activeTokens: 0,
      activeAccounts: 0,
      activePlatforms: 0,
      errorEvents: 0,
      avgDurationMs: null,
      p95DurationMs: null,
      lastSeenAt: null,
    },
    instrumentation: usageQuery.data?.instrumentation || {
      rawToolArgumentsEnabled: true,
      responsePreviewEnabled: true,
      dbLoggingDisabled: false,
      readonlyContainer: false,
    },
    platforms: usageQuery.data?.platforms || [],
    tools: usageQuery.data?.tools || [],
    actors: usageQuery.data?.actors || [],
    clients: usageQuery.data?.clients || [],
    recentEvents: usageQuery.data?.recentEvents || [],
    profiles: usageQuery.data?.profiles || [],
    options: usageQuery.data?.options || {
      platforms: [],
      profiles: [],
      tools: [],
    },
    generatedAt: usageQuery.data?.generatedAt || null,
    isLoading: usageQuery.isLoading,
    isFetching: usageQuery.isFetching,
    isError: usageQuery.isError,
    error: usageQuery.error,
    refetch: usageQuery.refetch,
  }
}
